import { PublicationTypes } from "../api/models.types";

export const publicationTypeDisplayMapper:{[key in PublicationTypes]: string} = {
    condolence:'ניחומים',
    obituary:'פטירה',
    remembrance:'אזכרה',
  }